/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { useGLTF } from '@react-three/drei'

export function Alien(props) {
  const { nodes, materials } = useGLTF('/models/alien.glb')
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Roundcube002.geometry}
        material={materials['Blue Alien']}
        position={[-0.006, 0.949, 0.304]}
        scale={0.534}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Sphere001.geometry}
        material={materials['Eyes Black']}
        position={[0.24, 0.714, 0.719]}
        rotation={[1.401, -0.566, -0.511]}
        scale={[-0.143, -0.093, -0.205]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Sphere002.geometry}
        material={materials['Eyes White']}
        position={[0.269, 0.761, 0.799]}
        rotation={[1.489, -0.121, -0.36]}
        scale={[0.066, 0.022, 0.066]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Sphere003.geometry}
        material={materials['Eyes White']}
        position={[0.2, 0.619, 0.806]}
        rotation={[1.895, -0.107, -0.153]}
        scale={[0.03, 0.01, 0.03]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Roundcube003.geometry}
        material={materials['White Alien']}
        position={[-0.006, 0.241, 0.282]}
        scale={0.187}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Roundcube005.geometry}
        material={materials['Blue Alien']}
        position={[0.285, 0.058, 0.767]}
        rotation={[2.426, -1.563, -2.477]}
        scale={[0.052, 0.076, 0.076]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Roundcube027.geometry}
        material={materials['Blue Alien']}
        position={[0.247, 0.03, 0.739]}
        rotation={[-2.03, -1.157, -0.683]}
        scale={[0.017, 0.041, 0.025]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.NurbsPath002.geometry}
        material={materials['Alien Black']}
        position={[-0.005, 0.395, 0.728]}
        scale={0.662}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Roundcube031.geometry}
        material={materials['White Alien']}
        position={[-0.232, 0.116, 0.641]}
        rotation={[-1.107, 0.274, -0.261]}
        scale={[0.065, 0.077, 0.065]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Roundcube032.geometry}
        material={materials['Blue Alien']}
        position={[-0.301, 0.081, 0.753]}
        rotation={[-1.107, 0.274, -0.261]}
        scale={[0.052, 0.076, 0.076]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Roundcube033.geometry}
        material={materials['Blue Alien']}
        position={[-0.254, 0.111, 0.753]}
        rotation={[-1.294, 0.655, -0.208]}
        scale={[0.017, 0.041, 0.025]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Roundcube004.geometry}
        material={materials['White Alien']}
        position={[0.24, 0.116, 0.637]}
        rotation={[1.869, -0.449, -0.197]}
        scale={[-0.065, -0.077, -0.065]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Sphere010.geometry}
        material={materials['Eyes Black']}
        position={[0.24, 0.714, 0.719]}
        rotation={[1.401, -0.566, -0.511]}
        scale={[-0.143, -0.093, -0.205]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Sphere011.geometry}
        material={materials['Eyes White']}
        position={[0.269, 0.761, 0.799]}
        rotation={[1.489, -0.121, -0.36]}
        scale={[0.066, 0.022, 0.066]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Sphere012.geometry}
        material={materials['Eyes White']}
        position={[0.2, 0.619, 0.806]}
        rotation={[1.895, -0.107, -0.153]}
        scale={[0.03, 0.01, 0.03]}
      />
    </group>
  )
}

useGLTF.preload('/models/alien.glb')
